import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

export default function GatewayForm({ item, action }) {
  const [id, setId] = useState(item?.id ?? "");
  const [name, setName] = useState(item?.name ?? "");
  const [description, setDescription] = useState(item?.description ?? "");
  const [status, setStatus] = useState(item?.status ?? 0);
  const [api, setApi] = useState(item?.api ?? "");
  const [cookies, setCookie, removeCookie] = useCookies();

  async function update() {
    const url = Constants.apiUrl + "/api/gateway/update";
    axios
      .get(
        url,
        {
          name: name,
          description: description,
          status: status,
        },
        {
          headers: {
            Authorization: "Bearer " + cookies.user_server_token,
          },
        }
      )
      .then((r) => {
        toast.success("تغییرات با موفقیت انجام شد");
      })
      .catch((e) => {});
  }
  return (
    <>
      <div>
        <label>نام</label>
        <input
          type="text"
          className="form-control"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
      </div>
      <div>
        <label>توضیحات</label>
        <input
          type="text"
          className="form-control"
          value={description}
          onChange={(e) => {
            setDescription(e.target.value);
          }}
        />
      </div>
      <div>
        <label>وضعیت</label>
        <select
          className="form-control"
          onChange={(e) => {
            setStatus(e.target.value);
          }}
        >
          <option value={1} selected={status == 1}>
            فعال
          </option>
          <option value={0} selected={status == 0}>
            غیرفعال
          </option>
        </select>
      </div>
      <div className="mt-4">
        <button
          onClick={() => {
            action(id,name,description,status);
          }}
          className="btn btn-success"
        >
          ثبت
        </button>
      </div>
    </>
  );
}
